import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  Table,
  notification,
  Breadcrumb,
  Tag,
  Modal,
  Spin,
  Popconfirm
} from 'antd';
import {
  PlusCircleTwoTone,
  DeleteOutlined,
} from '@ant-design/icons';
import _ from 'lodash';
import Cookies from 'js-cookie';
import API from '../utils/Api';

const { Search } = Input;

const Developer = () => {
  const myApi = new API({});
  myApi.createEntity({ name: 'user' });
  myApi.createEntity({ name: 'api-key' });
  
  const [appID] = useState(Cookies.get('appID'));
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [tittle, setTittle] = useState('');
  const [disabled, setDisabled] = useState(false);

  const fetchData = () => {
    setLoading(true);
    const apiArray = [myApi.endpoints.apiKey.getById({ id: appID })];
    Promise.all(apiArray)
      .then((res) => {
        const apiData = _.get(res[0],'data',[]);
        setUserData(apiData);
        setSearchData(apiData);
        setLoading(false);
      })
      .catch((err) =>
        notification.error({ message: 'Failed to load the data' })
      );
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onFinish = (values) => {
    setDisabled(true);
    values.app_id = appID;
    myApi.endpoints.apiKey.create(values).then((res) => {
      if (res.data) {
        notification.success({ message: 'API KEY Generated successfully.' });
        form.resetFields();
        setDisabled(false);
        setVisible(false);
        fetchData();
      } else {
        setDisabled(false);
        notification.error({ message: "Failed to generate the API KEY." });
      }
    }).catch((err) =>{
      setDisabled(false);
      notification.error({
        message:"Failed to generate the API KEY.",
      });
    });
  };
  const showDrawer = () => {
    setTittle('Generate API KEY');
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
    form.resetFields();
  };

  const globalSearch = (e) => {
    let { value } = e.target;
    let filteredData = [];
    value = value.toString().toLowerCase();
    if (!value) {
      filteredData.push(...searchData);
    } else {
      filteredData = searchData.filter((res) =>
        Object.keys(res).some(
          (resp) =>
            res[resp] && res[resp].toString().toLowerCase().includes(value)
        )
      );
    }
    setUserData(filteredData);
  };


  const handleDelete = (e, key) => {
    myApi.endpoints.apiKey.delete({ id: key.id }).then((res) => {
      if (res.data) {
        notification.success({ message: 'Deleted successfully' });
        fetchData();
      } else notification.error({ message: 'Failed to delete the API KEY' });
    });
  };
  const refreshData = (e) => {
    fetchData();
  };

  const columns = [
    {
      title: 'ACCESS NAME',
      dataIndex: 'title',
      width: 200,
      key:'id',
      fixed: 'left',
    },
    {
      title: 'ACCESS KEY',
      dataIndex: 'api_key',
      key: 'api_key',
      width: 250,
      fixed: 'left',
    },
    {
      title: 'Action',
      width: 100,
      align: 'right',
      render: (a) => (
        <span className='edit-box'>
          <Popconfirm
        placement="topRight"
        title={'Are you sure to delete this API KEY'}
        onConfirm={(e) => handleDelete(e, a)}
        okText="Yes"
        cancelText="No"
      >
         <Tag color='red'>
            <DeleteOutlined />
          </Tag>
      </Popconfirm>
        </span>
      ),
    },
  ];
  return (
    <Spin spinning={loading}>
      <div className='search-container'>
        <div>
          <Breadcrumb>
            <Breadcrumb.Item>Developer</Breadcrumb.Item>
            <Breadcrumb.Item>Keys</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div>
          <Search
            placeholder='Search'
            onChange={globalSearch}
            className='custom-search'
          />
        </div>
        <div>
          <Button type='primary' onClick={showDrawer} style={{marginRight:'8px'}}>
            <PlusCircleTwoTone /> Generate API Key
          </Button>
          <Button  type='primary' onClick={refreshData}>
            Refresh
          </Button>
        </div>
      </div>
      <div className='box'>
        <div className='box__header'>
          <h3 className='box-title'>ACCESS KEYS List</h3>
        </div>
        <div className='box__content p-0'>
          <Table
            className='grid-table'
            loading={loading}
            columns={columns}
            dataSource={userData}
          />
        </div>
      </div>
      <Modal 
      title={tittle} 
      onCancel={onClose} 
      visible={visible}
      footer={false}
      width={320}
      maskClosable={false}
      >
        <Spin spinning={disabled}>
        <Form
          form={form}
          className='apikey-form'
          layout='vertical'
          onFinish={onFinish}
        >
          <div>
            <Form.Item
              label='ACCESS NAME'
              name='title'
              rules={[
                {
                  required: true,
                  message: 'Please enter the filed!',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </div>
          <Form.Item style={{textAlign:'center'}}>
            <Button htmlType='submit' type='primary' disabled={disabled}>
              {disabled ? 'Generating...':'Generate'}
            </Button>
          </Form.Item>
        </Form>
        </Spin>
      </Modal>
    </Spin>
  );
};
export default Developer;
